module.exports = __webpack_public_path__ + "img/shanxi1.b2dc575d.png";